<template>
  <div
    ref="containerEl"
    class="relative opacity-100 dark:opacity-100 overflow-visible mx-auto md:mt-[-20px] mt-[-40px] max-md:mb-[-58px]"
    style="height: 165px"
    :style="containerWidthStyle"
    @mousemove="handleMouseMove"
    @mouseleave="handleMouseLeave"
  >
    <!-- Blur glow orb (light mode, desktop only) -->
    <div
      v-if="$colorMode.preference != 'dark' && isDesktop"
      class="max-md:hidden bg-[#EBCFFF50] size-[1046px] blur-[50px] absolute top-0 left-1/2 -translate-x-1/2 rounded-full"
    ></div>

    <!-- Base dim text (always visible) -->
    <span
      class="absolute inset-0 flex items-center justify-center font-avant select-none pointer-events-none"
      :style="{ fontSize: isDesktop ? '220px' : 'clamp(52px, 15vw, 220px)', lineHeight: isDesktop ? '220px' : '1.2' }"
    >
      <span :style="{ color: $colorMode.preference === 'dark' ? '#FFFFFF' : '#000000', opacity: isDesktop ? ($colorMode.preference === 'dark' ? 0.03 : 0.06) : 0.15, fontWeight: 600, letterSpacing: '-3px' }">web</span><span :style="{ color: $colorMode.preference === 'dark' ? '#FFFFFF' : '#000000', opacity: isDesktop ? ($colorMode.preference === 'dark' ? 0.03 : 0.06) : 0.15, fontWeight: 400, letterSpacing: '-3px' }">reinvent</span>
    </span>

    <!-- Glowing text (revealed only where cursor is, desktop only) -->
    <span
      v-if="isDesktop"
      class="absolute inset-0 flex items-center justify-center font-avant select-none pointer-events-none"
      :style="glowStyle"
      style="font-size: 220px; line-height: 220px"
    >
      <span
        :style="{
          fontWeight: 600,
          letterSpacing: '-3px',
          background: $colorMode.preference === 'dark'
            ? '#3E0D63'
            : '#6B3FAA',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
        }"
      >
        web
      </span>
      <span
        :style="{
          fontWeight: 400,
          letterSpacing: '-3px',
          background: $colorMode.preference === 'dark'
            ? '#3E0D63'
            : '#6B3FAA',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
        }"
      >
        reinvent
      </span>
    </span>
  </div>
</template>

<script setup lang="ts">
const { isDesktop } = useDevice();

const containerEl = ref<HTMLElement | null>(null);

const containerWidthStyle = computed(() => ({
  width: isDesktop ? '1350px' : '100%',
}));

const mouseX = ref(0);
const mouseY = ref(0);
const isHovering = ref(false);

const glowRadius = 180;

const glowStyle = computed(() => ({
  WebkitMaskImage: `radial-gradient(circle ${glowRadius}px at ${mouseX.value}px ${mouseY.value}px, rgba(0,0,0,1) 0%, rgba(0,0,0,0) 70%)`,
  maskImage: `radial-gradient(circle ${glowRadius}px at ${mouseX.value}px ${mouseY.value}px, rgba(0,0,0,1) 0%, rgba(0,0,0,0) 70%)`,
  opacity: isHovering.value ? 1 : 0,
  transition: isHovering.value ? 'none' : 'opacity 0.3s ease',
}));

function handleMouseMove(e: MouseEvent) {
  const rect = containerEl.value!.getBoundingClientRect();
  mouseX.value = e.clientX - rect.left;
  mouseY.value = e.clientY - rect.top;
  isHovering.value = true;
}

function handleMouseLeave() {
  isHovering.value = false;
}
</script>
